import { X } from 'lucide-react';

const Lightbox = ({ item, onClose }) => {
  if (!item) return null;
  return (
    <div className="mbid-lb" onClick={onClose}>
      <button className="mbid-lb__close" onClick={onClose}><X size={20} /></button>
      <div className="mbid-lb__content" onClick={e => e.stopPropagation()}>
        {item.type === 'video'
          ? <video src={item.url} controls autoPlay className="mbid-lb__media" />
          : <img src={item.url} alt="" className="mbid-lb__media" />}
      </div>
    </div>
  );
};

export default Lightbox;